import { createStyledContext, ViewProps } from 'tamagui';

export type PageContextType = {
  px?: ViewProps['px'];
};

export const PageContext = createStyledContext<PageContextType>({
  px: '$3'
});

export const { useStyledContext: usePageContext } = PageContext;
